import { render, staticRenderFns } from "./AddValueDetails.vue?vue&type=template&id=615c97c7&scoped=true&"
import script from "./AddValueDetails.vue?vue&type=script&lang=js&"
export * from "./AddValueDetails.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=615c97c7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c97c7",
  null
  
)

export default component.exports